<template>
  <div class="knowledge">
    <div class="title">
      <el-button
        class="back-btn"
        type="text"
        icon="el-icon-arrow-left"
        @click="$router.go(-1)"
        >返回</el-button
      >
      <b>知识考核</b>
      <div class="btn chapter_btn">
        <el-cascader
          v-model="classChapterId"
          @change="getQuestionInfo"
          :options="chapters"
          :props="{
            label: 'title',
            value: 'classChapterId',
            emitPath: false,
          }"
          :show-all-levels="false"
          size="mini"
          placeholder="请选择章节"
        ></el-cascader>

        <!-- <el-select
          v-model="classChapterId"
          placeholder="请选择章节"
          size="mini"
          @change="getQuestionInfo"
        >
          <el-option-group
            v-for="group in chapters"
            :key="group.classChapterId"
            :label="group.title"
          >
            <el-option
              v-for="item in group.children"
              :key="item.classChapterId"
              :label="item.title"
              :value="item.classChapterId"
            >
            </el-option>
          </el-option-group>
        </el-select> -->
      </div>
      <!-- <div class="btn export_btn">
        导出数据 <i class="el-icon-arrow-right"></i>
      </div> -->
    </div>
    <div class="main">
      <div class="box_title">客观题正确率</div>
      <div class="list" :class="{ 'm-bottom': noDo }">
        <template v-if="!noDo">
          <div
            class="one"
            :class="{ active: item.questionId == currentQuestion.questionId }"
            v-for="item in questionList"
            :key="item.questionId"
            @click="currentQuestion = item"
          >
            <div class="icon">
              <i class="el-icon-success" v-show="item.right"></i>
              <i class="el-icon-error" v-show="!item.right"></i>
            </div>
            <p class="num">{{ item.num }}</p>
          </div>
        </template>
        <p class="empty-tips" v-else>本章节测试未完成</p>
      </div>
      <div class="question_box" v-if="currentQuestion">
        <p class="stem">
          <span>{{ currentQuestion.num }}：</span>
          <span>{{ currentQuestion.question }}</span>
        </p>
        <p class="options">
          <span v-for="item in currentQuestion.optionList" :key="item.tag">
            {{ item.tag }}、{{ item.option }}
          </span>
        </p>
        <p class="info">
          <span>正确答案：{{ currentQuestion.answerList.join(" ") }}</span>
          <span
            >我的答案：{{
              [...currentQuestion.myAnswerList].sort().join(" ") || "无"
            }}</span
          >
        </p>
      </div>
      <div class="score_row">
        <div class="score_box" v-for="item in scoreList" :key="item.id">
          <p class="score_title">{{ item.title }}</p>
          <div class="circle_box">
            <el-progress
              type="circle"
              :percentage="item.score"
              stroke-linecap="square"
              :color="item.color"
              :width="105"
              :stroke-width="10"
              :format="format"
            ></el-progress>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userQuestion, userZs } from "@/api/evaluation";
import { chapterList } from "@/api/chapter";
import { handleTree } from "@/utils";

export default {
  data() {
    return {
      chapters: [],
      classChapterId: null,
      questionList: [],
      currentQuestion: null,
      noDo: false,
      scoreList: [
        {
          id: 1,
          title: "我的成绩",
          score: 0,
          color: "#aae476",
        },
        {
          id: 2,
          title: "班级最高分",
          score: 0,
          color: "#e1a82c",
        },
        {
          id: 3,
          title: "班级平均分",
          score: 0,
          color: "#5487c8",
        },
        {
          id: 4,
          title: "班级最低分",
          score: 0,
          color: "#c85463",
        },
      ],
    };
  },
  created() {
    this.getChapterList();
  },
  methods: {
    // 章节列表
    getChapterList() {
      chapterList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          //   console.log(res);
          let chapters = handleTree(res.data, "chapterId");

          chapters.forEach((item) => {
            if (item.children) {
              // 二级目录
              let secondArr = item.children;
              secondArr.forEach((s) => {
                if (s.children) {
                  // 三级目录为底层
                  let thirdArr = s.children;
                  let flag = thirdArr.every((t) => !t.complete);
                  if (flag) {
                    // 三级目录里全部未生成成绩
                    secondArr = secondArr.filter(
                      (n) => n.chapterId != s.chapterId
                    );
                  } else {
                    // 三级目录筛选
                    thirdArr.forEach((t) => {
                      if (!t.complete) {
                        thirdArr = thirdArr.filter(
                          (n) => n.chapterId != t.chapterId
                        );
                      }
                    });
                  }
                } else {
                  // 二级目录为底层
                  if (!s.complete) {
                    secondArr = secondArr.filter(
                      (n) => n.chapterId != s.chapterId
                    );
                  }
                }
              });
              // 一级目录的children赋值
              if (secondArr.length > 0) {
                item.children = secondArr;
              } else {
                delete item.children;
              }
            }
          });
          // 筛选掉一级目录中无children的，生成最终目录
          this.chapters = chapters.filter((item) => item.children);
          if (this.chapters[0].children[0].children) {
            this.classChapterId =
              this.chapters[0].children[0].children[0].classChapterId;
          } else {
            this.classChapterId = this.chapters[0].children[0].classChapterId;
          }
          this.getQuestionInfo();
        } else {
          console.log(res.msg);
        }
      });
    },
    getQuestionInfo() {
      this.getZs();
      this.$loading.show();
      userQuestion({
        classId: this.$route.query.id,
        classChapterId: this.classChapterId,
      }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.noDo = res.data.length == 0;
          res.data.forEach((item, idx) => {
            item.num = `第${idx + 1}题`;
          });
          this.questionList = res.data;
          this.currentQuestion = res.data[0];
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    format(percentage) {
      return percentage + "";
    },
    getZs() {
      userZs({
        classId: this.$route.query.id,
        classChapterId: this.classChapterId,
      }).then((res) => {
        if (res.code == 0) {
          this.scoreList[0].score = Number(res.data.userAvgScore.toFixed(1));
          this.scoreList[1].score = Number(res.data.maxScore.toFixed(1));
          this.scoreList[2].score = Number(res.data.avgScore.toFixed(1));
          this.scoreList[3].score = Number(res.data.minScore.toFixed(1));
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.knowledge {
  height: 748px;
  background-image: url("../../../../assets/images/evaluation_bg.png");
  background-size: cover;
  .title {
    position: relative;
    padding-top: 40px;
    height: 105px;
    text-align: center;
    background-image: url("../../../../assets/images/title_bg1.png");
    background-size: cover;
    .back-btn {
      position: absolute;
      left: 20px;
      top: 13px;
    }
    b {
      letter-spacing: 5px;
      font-size: 30px;
      color: transparent;
      background-image: linear-gradient(180deg, #fff, #fff, #1de0fe, #1de0fe);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .btn {
      position: absolute;
      top: 62px;
      width: 114px;
      height: 32px;
      line-height: 32px;
      color: #fff;
      background-image: url("../../../../assets/images/btn_bg.png");
      cursor: pointer;
      &.export_btn {
        right: 0;
      }
      &.chapter_btn {
        left: 0;
        ::v-deep .el-select,
        ::v-deep .el-cascader {
          .el-input__inner {
            padding-left: 15px;
          }
          .el-input__suffix {
            right: 6px;
          }
        }
      }
      ::v-deep .el-select,
      ::v-deep .el-cascader {
        .el-input__inner {
          padding-left: 20px;
          font-size: 14px;
          color: #fff;
          background-color: transparent;
          border: none;
        }
        .el-input__suffix {
          right: 10px;
          .el-select__caret {
            color: #fff;
          }
        }
      }
    }
  }
  .main {
    margin: 20px 2px 0;
    .box_title {
      padding: 0 10px;
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      color: #1de0fe;
      background-color: rgba(49, 70, 125, 0.1);
      // border: solid 1px rgba(4, 20, 40, 0.1);
      box-shadow: #6be4f7 0px 0px 5px inset;
    }
    .list {
      padding: 20px 15px;
      margin: 10px;
      text-align: left;
      box-shadow: rgba(27, 213, 246, 0.1) 0px 0px 24px inset;
      white-space: nowrap;
      overflow-x: auto;
      &::-webkit-scrollbar {
        height: 6px;
        background-color: rgb(14, 88, 113);
      }

      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px rgba(14, 88, 113, 0.3);
        -webkit-box-shadow: inset 0 0 6px rgba(14, 88, 113, 0.3);
        background-color: rgb(14, 88, 113);
      }

      &::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 6px rgba(27, 213, 246, 0.1);
        -webkit-box-shadow: inset 0 0 6px rgba(27, 213, 246, 0.1);
        background-color: #1ae0fe;
      }
      &.m-bottom {
        margin-bottom: 244px;
      }
      .one {
        display: inline-block;
        margin: 0 15px;
        cursor: pointer;
        &.active {
          .num {
            color: #fff;
          }
        }
        &:hover {
          .icon {
            transform: scale(1.1, 1.1);
          }
          .num {
            color: #fff;
          }
        }
        .icon {
          transition: all 0.3s ease;
          font-size: 50px;
          .el-icon-success {
            color: #6be015;
          }
          .el-icon-error {
            color: #ff3f3f;
          }
        }
        .num {
          margin-top: 30px;
          font-size: 15px;
          text-align: center;
          color: rgba(101, 198, 231, 0.5);
          transition: all 0.3s ease;
        }
      }

      .empty-tips {
        text-align: center;
        font-size: 20px;
        color: #fff;
      }
    }
    .question_box {
      position: relative;
      padding: 30px;
      min-height: 138px;
      text-align: left;
      color: #fff;
      .stem {
        font-weight: bold;
      }
      .options {
        margin-top: 10px;
        span {
          margin-right: 10px;
        }
      }
      .info {
        margin-top: 10px;
        span {
          margin-right: 30px;
        }
      }
    }
    .score_row {
      margin: 15px 10px 0;
      text-align: left;
      .score_box {
        display: inline-block;
        margin: 0 12px;
        width: 270px;
        &:first-child {
          ::v-deep .el-progress__text,
          .text {
            color: #aae476;
          }
        }
        &:nth-child(2) {
          ::v-deep .el-progress__text,
          .text {
            color: #e1a82c;
          }
        }
        &:nth-child(3) {
          ::v-deep .el-progress__text,
          .text {
            color: #5487c8;
          }
        }
        &:nth-child(4) {
          ::v-deep .el-progress__text,
          .text {
            color: #c85463;
          }
        }
        .score_title {
          padding: 0 10px;
          height: 48px;
          line-height: 48px;
          font-size: 16px;
          color: #1de0fe;
          text-align: center;
          background-color: rgba(49, 70, 125, 0.1);
          // border: solid 1px rgba(4, 20, 40, 0.1);
          box-shadow: #1de0fe 0px 0px 5px inset;
        }
        .circle_box {
          position: relative;
          padding-top: 40px;
          height: 190px;
          text-align: center;
          box-shadow: rgba(27, 213, 246, 0.1) 0px 0px 24px inset;
          ::v-deep .el-progress__text {
            // padding-right: 10px;
            font-size: 30px !important;
          }
          .text {
            position: absolute;
            top: 46%;
            right: 39%;
          }
        }
      }
    }
  }
}
</style>